import { render } from "./GaoJing.vue?vue&type=template&id=3315fe8a&scoped=true"
import script from "./GaoJing.vue?vue&type=script&lang=js"
export * from "./GaoJing.vue?vue&type=script&lang=js"

import "./GaoJing.vue?vue&type=style&index=0&id=3315fe8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3315fe8a"]])

export default __exports__